/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * The returned Promise fails if cookies are not accepted and resolves if they are accepted.
 */
export const isCookieConsentAccepted = (): Promise<void> => {
    return new Promise((resolve, reject) => {
        if ((window as any)?.trumpf?.ux?.uiCookieConsent) {
            const hasConsentedOptional = (
                window as any
            ).trumpf.ux.uiCookieConsent.hasConsented("optional");
            if (hasConsentedOptional) {
                resolve();
            } else {
                reject();
            }
            return;
        }
        reject();
    });
};
